export const ZYP_LOGO_URL = `${process.env.PUBLIC_URL || ""}/zyp-logo.png`;

const VARIANTS = {
  nav: "h-9 md:h-10 w-auto",
  footer: "h-10 md:h-11 w-auto",
};

export function ZypLogo({ variant = "nav", className = "" }) {
  return (
    <img
      src={ZYP_LOGO_URL}
      alt="Zyp — The smarter way to shine"
      className={`block object-contain object-left ${VARIANTS[variant] || VARIANTS.nav} ${className}`}
      decoding="async"
    />
  );
}
